import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ClarityBootstrap from "@/components/ClarityBootstrap";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ClarityBootstrap />
    <App />
  </React.StrictMode>,
);
